module.exports = __webpack_public_path__ + "static/animal-dental-care-57363a3f3906cf52c137727732fb17c8.jpg";